/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
    const productThumbs = new Swiper('.product-single__thumbnails-swiper', {
        slidesPerView: 6,
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.product-single__thumbnails-next',
            prevEl: '.product-single__thumbnails-prev',
        },
        breakpoints: {
            1200: {
                slidesPerView: 5,
                direction: 'vertical',
                spaceBetween: 0,
            }
        }
    });
    const productGallery = new Swiper('.product-single__gallery-swiper', {
        autoHeight: true,
        loop: true,
        navigation: {
            nextEl: '.product-single__gallery-next',
            prevEl: '.product-single__gallery-prev',
        },
        thumbs: {
            swiper: productThumbs,
        },
    });
    /*
    const productGallery = new Swiper('.product-single__gallery-swiper', {
        loop: true,
        autoHeight: true,
        navigation: {
            nextEl: '.product-single__gallery-next',
            prevEl: '.product-single__gallery-prev',
        },
    });
    const productThumbs = new Swiper('.product-single__thumbnails-swiper', {
        slidesPerView: 5,
        spaceBetween: 10,
        navigation: {
            nextEl: '.product-single__thumbnails-next',
            prevEl: '.product-single__thumbnails-prev',
        },
        on: {
            click: function (swiper, event) {
                swiper.slideTo(swiper.clickedIndex);
                productGallery.slideTo(swiper.clickedIndex);
                swiper.updateSlidesClasses();
            }
        },
        breakpoints: {
            1200: {
                direction: 'vertical',
                spaceBetween: 0,
            }
        }
    });

     */
})();
